import {useDispatch, useSelector} from "react-redux";
import {useEffect} from "react";
import {acquireActions} from "../../../../../../_actions";
import {CampaignsMetricsBuilder} from "../objects/CampaignsMetricsBuilder";
import _ from "lodash";

export default function ({startDate, endDate}) {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(acquireActions.getCompanyAcquireMetrics({startDate, endDate}));
    }, [startDate, endDate]);

    const acquireMetrics = useSelector(state => state.acquire);
    const loading = acquireMetrics.loadingAcquireMetrics;
    const campaignsMetrics = acquireMetrics.acquireMetrics;
    const builder = new CampaignsMetricsBuilder()

    if(!loading) {
        builder.setEngagements(_.get(campaignsMetrics, 'engagements') || '-')
        builder.setLikes(_.get(campaignsMetrics, 'likes') || '-');
        builder.setReplies(_.get(campaignsMetrics, 'replies') || '-');
        builder.setFollows(_.get(campaignsMetrics, 'follows') || '-');
    }

    const data = builder.metrics || {};
    return { loading, data };
}